exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-free-prototype-tsx": () => import("./../../../src/templates/FreePrototype.tsx" /* webpackChunkName: "component---src-templates-free-prototype-tsx" */)
}

